export const LOCAL_STORAGE_TOKEN_KEY = "TOKEN";
export const LOCAL_STORAGE_USER_KEY = "DATA";

